import React from 'react';
import PropTypes from 'prop-types';
import { USER_TYPE } from '../../helper/constant/userType';

const AccessRestrictedMessage = ({ userType }) => {
  const message =
    userType === USER_TYPE.BUYER || userType === USER_TYPE.ALL
      ? 'กรุณาติดต่อ Line @meya หากต้องการขายสินค้ากับเรา'
      : 'กรุณาติดต่อ Line @meya หากต้องการซื้อสินค้ากับเรา';

  return (
    <div
      style={{
        display: 'flex',
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        height: 'auto',
        backgroundColor: '#fff',
        zIndex: 5001,
        borderRadius: '5px',
        border: 'none',
        padding: '20px',
        justifyContent: 'center',
        fontFamily: 'Kanit',
        fontSize: '16px',
        verticalAlign: 'middle',
        alignItems: 'center',
      }}
    >
      <i className='fas fa-info-circle text-primary mr-2'></i> {message}
    </div>
  );
};

AccessRestrictedMessage.propTypes = {
  userType: PropTypes.oneOf([USER_TYPE.BUYER, USER_TYPE.SELLER, USER_TYPE.ALL]),
};

export default AccessRestrictedMessage;
